import classNames from 'classnames';
import { useState, useEffect, forwardRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { isServerSide } from 'helpers/ssr';
import { Button } from 'palette/Button';
import { useConfig } from '@common/Hooks/useConfig';
import { useScrollDirection } from '@common/Hooks/useScrollDirection';
import { isBooztmobile } from '@helpers/env';
import '../styles/ScrollToTop.scss';

function ScrollToTop(props, ref) {
    const config = useConfig();
    const [visibleScrollToTop, setVisibleScrollToTop] = useState(false);
    const scrollDirection = useScrollDirection();
    const isMobile = useMediaQuery({ maxWidth: 767 }) || isBooztmobile(config);

    let footerElement;

    if (!isServerSide()) {
        [footerElement] = document.getElementsByClassName('react-footer-body');
    }

    const scrollToElement = ref?.current;
    const scrollToElementOffset = scrollToElement?.offsetTop;

    const handleVisibleButton = () => {
        const footerIsInView = footerElement?.getBoundingClientRect().top <= window.innerHeight;

        if (isMobile) {
            return setVisibleScrollToTop(scrollDirection === 'up' && window.scrollY > scrollToElementOffset);
        }

        return setVisibleScrollToTop(window.scrollY > 1400 && !footerIsInView);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleVisibleButton);

        return () => {
            window.removeEventListener('scroll', handleVisibleButton);
        };
    });

    const handleScrollToTop = () => {
        scrollToElement.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className={classNames(`scroll-top-button${isMobile ? '__mobile' : ''}`,
            { invisible: !visibleScrollToTop })}
        >
            <Button
                iconColor="white"
                iconName="palette_chevron_up"
                shape="round"
                theme="primary"
                onClick={() => handleScrollToTop()}
            />
        </div>
    );
}

export default forwardRef(ScrollToTop);
